import React from 'react';

import { DashboardTemplate } from '@hero/components';

export default function HomePage() {
  return <DashboardTemplate />;
}
